/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfirmUploadApiResponse } from '../models/ConfirmUploadApiResponse';
import type { DeleteExpertDocumentApiResponse } from '../models/DeleteExpertDocumentApiResponse';
import type { DeleteExpertImageApiResponse } from '../models/DeleteExpertImageApiResponse';
import type { ExpertDocumentUrlApiResponse } from '../models/ExpertDocumentUrlApiResponse';
import type { ExpertVerificationApiResponse } from '../models/ExpertVerificationApiResponse';
import type { PresignedUrlApiResponse } from '../models/PresignedUrlApiResponse';
import type { RequestExpertDocumentsApiResponse } from '../models/RequestExpertDocumentsApiResponse';
import type { VerifyExpertDocumentApiResponse } from '../models/VerifyExpertDocumentApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MediaService {
    /**
     * Delete expert gallery image
     * Delete an expert gallery image (testimonial, gallery, etc.) from DB and S3. Expert only. The image must belong to the authenticated expert.
     * @param imageId Expert image UUID to delete
     * @returns DeleteExpertImageApiResponse Image deleted successfully
     * @throws ApiError
     */
    public static mediaControllerDeleteExpertImageV1(
        imageId: string,
    ): CancelablePromise<DeleteExpertImageApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/media/experts/images/{imageId}',
            path: {
                'imageId': imageId,
            },
            errors: {
                403: `Forbidden - Expert access required`,
                404: `Not Found - Image not found or not owned by expert`,
                429: `Too Many Requests - Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete expert document
     * Delete an expert document from DB and S3. Expert only. The document must belong to the authenticated expert.
     * @param id Expert document UUID to delete
     * @returns DeleteExpertDocumentApiResponse Document deleted successfully
     * @throws ApiError
     */
    public static mediaControllerDeleteExpertDocumentV1(
        id: string,
    ): CancelablePromise<DeleteExpertDocumentApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/media/expert-documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden - Expert access required`,
                404: `Not Found - Document not found or not owned by expert`,
                429: `Too Many Requests - Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get pre-signed URL(s) for file upload
     * Generate pre-signed URL(s) for direct-to-S3 upload. Send a **single object** or an **array of objects** for multiple files. Requires JWT. Response is always an array (one item per file).
     * @param requestBody Single file: one object. Multiple files: array of objects with fileType, fileName, category, optional documentType.
     * @returns PresignedUrlApiResponse Pre-signed URL(s) generated successfully. Data is always an array.
     * @throws ApiError
     */
    public static mediaControllerGetPresignedUrlV1(
        requestBody: {
            /**
             * MIME type of the file
             */
            fileType: 'image/jpeg' | 'image/png' | 'image/heic' | 'application/pdf';
            /**
             * Original filename
             */
            fileName: string;
            /**
             * Upload category
             */
            category: 'expert_document' | 'expert_gallery_image' | 'profile_photo';
            /**
             * Document type (required for expert_document category)
             */
            documentType?: 'cpr_certification' | 'first_aid_certification' | 'pt_certification' | 'highest_education' | 'bachelors_degree' | 'masters_degree' | 'internship_certificate' | 'professional_license' | 'work_experience_proof' | 'ma_msc_psychology' | 'mphil_psyd' | 'child_certification' | 'active_listening_training' | 'additional_certification' | 'other' | 'passport' | 'emirates_id' | 'aadhar_card';
        },
    ): CancelablePromise<PresignedUrlApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/media/presigned-url',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Invalid file type or missing documentType`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Confirm file upload(s)
     * Confirm upload(s) after client has uploaded file(s) directly to S3. Send a **single object** or an **array of objects** (one per file). Response is always an array.
     * @param requestBody Single upload: one object with fileKey, category, optional documentType. Multiple: array of such objects.
     * @returns ConfirmUploadApiResponse Upload(s) confirmed successfully. Data is always an array.
     * @throws ApiError
     */
    public static mediaControllerConfirmUploadV1(
        requestBody: {
            /**
             * S3 file key returned from presigned-url endpoint
             */
            fileKey: string;
            /**
             * Upload category
             */
            category: 'expert_document' | 'expert_gallery_image' | 'profile_photo';
            /**
             * Document type (required for expert_document category)
             */
            documentType?: 'cpr_certification' | 'first_aid_certification' | 'pt_certification' | 'highest_education' | 'bachelors_degree' | 'masters_degree' | 'internship_certificate' | 'professional_license' | 'work_experience_proof' | 'ma_msc_psychology' | 'mphil_psyd' | 'child_certification' | 'active_listening_training' | 'additional_certification' | 'other' | 'passport' | 'emirates_id' | 'aadhar_card';
        },
    ): CancelablePromise<ConfirmUploadApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/media/confirm',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - File not found or missing documentType`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update expert verification status
     * Set the verification status for an expert. Admin only. Status values: pending, in_progress, verified, rejected, resubmission_required.
     * @param expertId Expert UUID
     * @param requestBody Verification status and optional notes
     * @returns ExpertVerificationApiResponse Expert verification updated successfully
     * @throws ApiError
     */
    public static mediaControllerUpdateExpertVerificationV1(
        expertId: string,
        requestBody: {
            /**
             * Expert verification status
             */
            status: 'pending' | 'in_progress' | 'verified' | 'rejected' | 'resubmission_required';
            /**
             * Optional notes from admin
             */
            verificationNotes?: string;
        },
    ): CancelablePromise<ExpertVerificationApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/media/experts/{expertId}/verification',
            path: {
                'expertId': expertId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden - Only admins can update expert verification`,
                404: `Not Found - Expert not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Request additional documents from an expert
     * Create one or more document requests for an expert. Admin only. Creates placeholder expert_documents rows with status = resubmission_required and no file attached.
     * @param expertId Expert UUID
     * @param requestBody Document types to request from the expert and an optional message explaining the request.
     * @returns RequestExpertDocumentsApiResponse Document request(s) created successfully
     * @throws ApiError
     */
    public static mediaControllerRequestExpertDocumentsV1(
        expertId: string,
        requestBody: {
            items: Array<{
                /**
                 * Type of document being requested
                 */
                documentType: 'cpr_certification' | 'first_aid_certification' | 'pt_certification' | 'highest_education' | 'bachelors_degree' | 'masters_degree' | 'internship_certificate' | 'professional_license' | 'work_experience_proof' | 'ma_msc_psychology' | 'mphil_psyd' | 'child_certification' | 'active_listening_training' | 'additional_certification' | 'other' | 'passport' | 'emirates_id' | 'aadhar_card';
            }>;
            /**
             * Optional message to the expert explaining why these documents are needed or providing additional instructions.
             */
            message?: string;
        },
    ): CancelablePromise<RequestExpertDocumentsApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/media/experts/{expertId}/document-requests',
            path: {
                'expertId': expertId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden - Only admins can request expert documents`,
                404: `Not Found - Expert not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get document requirements for an expert category
     * Returns document requirements for the given expert category. ID-proof options (e.g. emirates_id vs aadhar_card) are filtered by the expert’s phone country code. When `expertId` is omitted, the current user’s phone code is used (expert app). When `expertId` is set, the target expert’s phone code is used (admin only).
     * @param category Expert category
     * @param expertId Optional expert UUID. When set, ID options follow this expert’s phone country (admins only). Omit for the authenticated expert’s own onboarding.
     * @returns any Document requirements fetched successfully
     * @throws ApiError
     */
    public static mediaControllerGetExpertDocumentRequirementsV1(
        category: 'personal_trainer' | 'physiotherapist' | 'psychologist' | 'trained_listener',
        expertId?: any,
    ): CancelablePromise<{
        statusCode?: number;
        status?: string;
        message?: string;
        data?: {
            category?: 'personal_trainer' | 'physiotherapist' | 'psychologist' | 'trained_listener';
            documentTypes?: Array<'cpr_certification' | 'first_aid_certification' | 'pt_certification' | 'highest_education' | 'bachelors_degree' | 'masters_degree' | 'internship_certificate' | 'professional_license' | 'work_experience_proof' | 'ma_msc_psychology' | 'mphil_psyd' | 'child_certification' | 'active_listening_training' | 'additional_certification' | 'other' | 'passport' | 'emirates_id' | 'aadhar_card'>;
            /**
             * Document requirements grouped by category.
             */
            requirements?: Array<{
                /**
                 * Document category
                 */
                category?: 'id_proof' | 'certification' | 'education' | 'other';
                /**
                 * Whether uploading at least minFiles from this group is required for onboarding
                 */
                required?: boolean;
                /**
                 * Minimum number of files required from this group (0 = optional)
                 */
                minFiles?: number;
                /**
                 * Document types available in this category
                 */
                items?: Array<{
                    /**
                     * Document type code
                     */
                    code?: string;
                    /**
                     * Human-readable label for UI
                     */
                    label?: string;
                }>;
            }>;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/media/experts/document-requirements',
            query: {
                'category': category,
                'expertId': expertId,
            },
        });
    }
    /**
     * Verify expert document
     * Approve, reject, or request documents for an expert document. Only admins can perform verification. Rejection requires a reason.
     * @param id Expert document UUID
     * @param requestBody Verification action and optional rejection reason
     * @returns VerifyExpertDocumentApiResponse Document verification updated successfully
     * @throws ApiError
     */
    public static mediaControllerVerifyExpertDocumentV1(
        id: string,
        requestBody: {
            /**
             * approve, reject, or request_documents
             */
            action: 'approve' | 'reject' | 'request_documents';
            /**
             * Required when action is reject
             */
            rejectionReason?: string;
        },
    ): CancelablePromise<VerifyExpertDocumentApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/media/expert-documents/{id}/verify',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Rejection reason required when rejecting`,
                403: `Forbidden - Only admins can verify documents`,
                404: `Not Found - Expert document not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get signed URL for an expert document
     * Returns a short-lived signed URL to download a single expert document. Owning experts and admins can access expert documents.
     * @param id Expert document ID
     * @returns ExpertDocumentUrlApiResponse Signed expert document URL generated successfully
     * @throws ApiError
     */
    public static mediaControllerGetExpertDocumentUrlV1(
        id: string,
    ): CancelablePromise<ExpertDocumentUrlApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/media/expert-documents/{id}/url',
            path: {
                'id': id,
            },
        });
    }
}
